const appInfo = {
    title: 'Mobility 3.0'
};
export default appInfo;

